module.exports = {
  ENVIRONMENT: "prod",
  WEBSITE_DOMAIN: "http://www.3tekeji.com",
  LOGIN_DOMAIN: "https://login.3tekeji.com",
  SME_DOMAIN: "https://sme.3tekeji.com",
  TMS_DOMAIN: "https://tms.3tekeji.com",
  AMB_DOMAIN: "https://amb.3tekeji.com",
  FMS_DOMAIN: "https://fms.3tekeji.com",
  PSI_DOMAIN: "https://psi.3tekeji.com",
  OA_DOMAIN: "https://oa.3tekeji.com",
  CRM_DOMAIN: "https://crm.3tekeji.com",
  JAVA_BASE_ADDR: "https://sme.3tekeji.com/api2"
};
